import { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation, Link, NavLink } from 'react-router-dom';
import { useCurrentUser } from '../hooks/useCurrentUser';
import { authenticationService } from '../services/authenticationService';
import PlayerSearchTypeahead from './PlayerSearchTypeahead';
import HeaderStripePortalLink from "../pages/Account/HeaderStripePortalLink";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Dropdown, Overlay } from "react-bootstrap";
import HelperFunctions from '../helpers/HelperFunctions';
import { getUnreadCount } from '../helpers/notificationHelpers';
import sk from '../images/SK.png'
const Header = () => {

    const [currentUser] = useCurrentUser();
    const [showPlayerSearch, setShowPlayerSearch] = useState(false);
    const [showMobilePlayerSearch, setShowMobilePlayerSearch] = useState(false);
    const [showAccountDropdown, setShowAccountDropdown] = useState(false);
    const [show, setShow] = useState(false);
    const [scrollDirection, setScrollDirection] = useState('up');
    const [isScrolled, setIsScrolled] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);

    const playerSearchTarget = useRef(null);
    const playerSearchMobileTarget = useRef(null);
    const lastScrollY = useRef(0);

    const navigate = useNavigate();

    const { addClassToBody, removeClassFromBody } = HelperFunctions();

    const location = useLocation();

    const insightPaths = ['/my-news', '/ai-summaries', '/saved/news', '/saved/searches', '/saved/following/players', '/saved/following/teams'];
    const teamsPaths = ['/teams-listing', '/reports/team-transfer-analysis'];

    useEffect(() => {
        setShowPlayerSearch(false);
        setShowMobilePlayerSearch(false);
    }, [location]);

    useEffect(() => {
        setShowPlayerSearch(false);
        setShowMobilePlayerSearch(false);

        const subscription = authenticationService.currentUser.subscribe(user => {
            if (user) {
                fetchUnreadCount();
            }
        });

        return () => subscription.unsubscribe();
    }, []);

    const fetchUnreadCount = async () => {
        try {
            const count = await getUnreadCount();
            setUnreadCount(count);
        } catch (error) {
            console.error('Error fetching unread count:', error);
        }
    };

    useEffect(() => {
        const handleNotificationsUpdated = () => {
            fetchUnreadCount();
        };

        window.addEventListener('notificationsUpdated', handleNotificationsUpdated);
        return () => window.removeEventListener('notificationsUpdated', handleNotificationsUpdated);
    }, []);

    const onPlayerSearchTypeaheadSelect = () => {
        setShowPlayerSearch(false);

    }

    const handleLogout = () => {
        authenticationService.logout();
        navigate('/login');
    };

    const closeMenu = () => setShow(false);
    const handleMenuOpen = () => setShow(true);

    const [activeSection, setActiveSection] = useState('');

    const toggleShowMobilePlayerSearch = () => {
        if (showMobilePlayerSearch) {
            setShowMobilePlayerSearch(false);
            removeClassFromBody(playerSearchMobileTarget.current, 'position-relative');
        } else {
            setShowMobilePlayerSearch(true);
            addClassToBody(playerSearchMobileTarget.current, 'position-relative');
        }
        closeMenu();
    }

    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setActiveSection(entry.target.id);
                    }
                });
            },
            {
                root: null,
                rootMargin: '-40% 0px 0px 0px',
                threshold: 0
            }
        );

        setTimeout(() => {
            ['Walkthrough', 'Features', 'Pricing'].forEach(id => {
                const el = document.getElementById(id);
                if (el) observer.observe(el);
            });
        }, 50);

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > 50) {
                setIsScrolled(true);
                if (currentScrollY > lastScrollY.current) {
                    setScrollDirection('down');
                } else {
                    setScrollDirection('up');
                }
            } else {
                setIsScrolled(false);
                setScrollDirection('up');
            }

            lastScrollY.current = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleScrollToSection = (e, id) => {
        e.preventDefault();
        const el = document.getElementById(id);
        if (el) {
            const yOffset = -120;
            const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };



    return (


        <header className={`transition-transform pt-3 pt-md-0 z-index-modal-backdrop ${isScrolled && scrollDirection === 'down' ? 'translate-y-n100' : ''} ${isScrolled && scrollDirection === 'up' ? 'position-sticky top-0 ' : 'position-relative'}`}>
            <div>
                {/* desktop nav */}
                <nav className={`d-none d-md-flex navbar navbar-expand-lg navbar-dark w-100 py-3 ${!currentUser && location.pathname === '/' ? 'bg-blur-10' : ''}`}>
                    <div className='container d-flex justify-content-between'>
                        <Link to={`${currentUser ? '/dashboard' : '/'}`}>
                            <svg width="224" height="30" viewBox="0 0 1443 204" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.56 47.18C4.56 41.02 5.88 35.2267 8.52 29.8C11.16 24.2267 14.7533 19.3867 19.3 15.28C23.9933 11.1733 29.3467 7.94666 35.36 5.59999C41.52 3.25332 48.12 2.07999 55.16 2.07999C62.4933 2.07999 69.3867 3.25332 75.84 5.59999C82.2933 7.79999 87.94 11.0267 92.78 15.28C97.62 19.3867 101.507 24.3 104.44 30.02C107.52 35.74 109.207 42.12 109.5 49.16H82.66C82.22 45.64 81.12 42.4867 79.36 39.7C77.6 36.9133 75.4733 34.5667 72.98 32.66C70.4867 30.6067 67.7 29.0667 64.62 28.04C61.54 26.8667 58.3867 26.28 55.16 26.28C51.7867 26.28 48.6333 26.8667 45.7 28.04C42.7667 29.0667 40.2 30.5333 38 32.44C35.8 34.3467 34.04 36.5467 32.72 39.04C31.5467 41.5333 30.96 44.2467 30.96 47.18C30.96 50.4067 32.06 53.2667 34.26 55.76C36.6067 58.2533 39.6133 60.5267 43.28 62.58C47.0933 64.4867 51.42 66.1733 56.26 67.64C61.2467 69.1067 66.38 70.5 71.66 71.82C77.6733 73.2867 83.32 75.34 88.6 77.98C93.88 80.4733 98.4267 83.6267 102.24 87.44C106.2 91.1067 109.28 95.4333 111.48 100.42C113.68 105.26 114.78 110.76 114.78 116.92C114.78 123.96 113.24 130.56 110.16 136.72C107.227 142.733 103.193 148.087 98.06 152.78C92.9267 157.327 86.84 160.92 79.8 163.56C72.9067 166.2 65.5 167.52 57.58 167.52C50.1 167.52 42.9133 166.127 36.02 163.34C29.1267 160.407 23.04 156.52 17.76 151.68C12.48 146.693 8.3 140.9 5.22 134.3C2.14 127.7 0.6 120.733 0.6 113.4H27.44C27.7333 117.36 28.6133 121.173 30.08 124.84C31.6933 128.507 33.82 131.733 36.46 134.52C39.1 137.16 42.18 139.287 45.7 140.9C49.3667 142.513 53.3267 143.32 57.58 143.32C61.8333 143.32 65.7933 142.66 69.46 141.34C73.2733 139.873 76.5733 137.967 79.36 135.62C82.1467 133.127 84.3467 130.34 85.96 127.26C87.5733 124.033 88.38 120.587 88.38 116.92C88.38 109.587 85.08 103.94 78.48 99.98C72.0267 96.02 63.1533 92.6467 51.86 89.86C44.82 88.1 38.3667 85.9 32.5 83.26C26.78 80.62 21.7933 77.6133 17.54 74.24C13.4333 70.72 10.2067 66.76 7.86 62.36C5.66 57.8133 4.56 52.7533 4.56 47.18ZM194.882 41.68C203.829 41.68 212.189 43.3667 219.962 46.74C227.882 49.9667 234.776 54.44 240.642 60.16C246.509 65.88 251.129 72.5533 254.502 80.18C257.876 87.8067 259.562 95.9467 259.562 104.6C259.562 113.253 257.876 121.393 254.502 129.02C251.129 136.647 246.509 143.32 240.642 149.04C234.776 154.76 227.882 159.307 219.962 162.68C212.189 165.907 203.829 167.52 194.882 167.52C187.256 167.52 180.142 165.98 173.542 162.9C166.942 159.82 161.296 155.713 156.602 150.58V203.6H130.202V104.6C130.202 95.9467 131.889 87.8067 135.262 80.18C138.636 72.5533 143.256 65.88 149.122 60.16C154.989 54.44 161.809 49.9667 169.582 46.74C177.502 43.3667 185.936 41.68 194.882 41.68ZM194.442 143.76C199.722 143.76 204.709 142.733 209.402 140.68C214.096 138.627 218.202 135.84 221.722 132.32C225.242 128.8 228.029 124.693 230.082 120C232.136 115.16 233.162 110.027 233.162 104.6C233.162 99.1733 232.136 94.1133 230.082 89.42C228.029 84.58 225.242 80.4 221.722 76.88C218.202 73.36 214.096 70.5733 209.402 68.52C204.709 66.4667 199.722 65.44 194.442 65.44C189.162 65.44 184.176 66.4667 179.482 68.52C174.789 70.5733 170.682 73.36 167.162 76.88C163.642 80.4 160.856 84.58 158.802 89.42C156.749 94.1133 155.722 99.1733 155.722 104.6C155.722 110.027 156.749 115.16 158.802 120C160.856 124.693 163.642 128.8 167.162 132.32C170.682 135.84 174.789 138.627 179.482 140.68C184.176 142.733 189.162 143.76 194.442 143.76ZM336.837 41.68C345.784 41.68 354.217 43.3667 362.137 46.74C370.057 49.9667 376.951 54.44 382.817 60.16C388.684 65.88 393.304 72.5533 396.677 80.18C400.051 87.8067 401.737 95.9467 401.737 104.6C401.737 113.253 400.051 121.393 396.677 129.02C393.304 136.647 388.684 143.32 382.817 149.04C376.951 154.76 370.057 159.307 362.137 162.68C354.217 165.907 345.784 167.52 336.837 167.52C327.891 167.52 319.457 165.907 311.537 162.68C303.617 159.307 296.724 154.76 290.857 149.04C284.991 143.32 280.371 136.647 276.997 129.02C273.624 121.393 271.937 113.253 271.937 104.6C271.937 95.9467 273.624 87.8067 276.997 80.18C280.371 72.5533 284.991 65.88 290.857 60.16C296.724 54.44 303.617 49.9667 311.537 46.74C319.457 43.3667 327.891 41.68 336.837 41.68ZM336.837 143.76C342.117 143.76 347.104 142.733 351.797 140.68C356.491 138.627 360.597 135.84 364.117 132.32C367.637 128.8 370.351 124.693 372.257 120C374.311 115.16 375.337 110.027 375.337 104.6C375.337 99.1733 374.311 94.1133 372.257 89.42C370.351 84.58 367.637 80.4 364.117 76.88C360.597 73.36 356.491 70.5733 351.797 68.52C347.104 66.4667 342.117 65.44 336.837 65.44C331.557 65.44 326.571 66.4667 321.877 68.52C317.184 70.5733 313.077 73.36 309.557 76.88C306.037 80.4 303.251 84.58 301.197 89.42C299.291 94.1133 298.337 99.1733 298.337 104.6C298.337 110.027 299.291 115.16 301.197 120C303.251 124.693 306.037 128.8 309.557 132.32C313.077 135.84 317.184 138.627 321.877 140.68C326.571 142.733 331.557 143.76 336.837 143.76ZM476.204 65.44C471.657 65.44 467.331 66.32 463.224 68.08C459.264 69.84 455.817 72.1867 452.884 75.12C449.951 78.0533 447.604 81.5733 445.844 85.68C444.084 89.64 443.204 93.8933 443.204 98.44V164H416.804V100.2C416.804 92.1333 418.344 84.58 421.424 77.54C424.504 70.3533 428.684 64.12 433.964 58.84C439.244 53.56 445.404 49.38 452.444 46.3C459.631 43.22 467.257 41.68 475.324 41.68H476.204V65.44ZM550.581 167.52H547.281C539.361 167.52 531.881 166.053 524.841 163.12C517.948 160.04 511.934 155.933 506.801 150.8C501.668 145.667 497.561 139.653 494.481 132.76C491.548 125.72 490.081 118.24 490.081 110.32V5.59999H516.481V45.2H550.581V68.08H516.481V110.76C516.481 115.307 517.361 119.633 519.121 123.74C520.881 127.7 523.228 131.147 526.161 134.08C529.094 137.013 532.541 139.36 536.501 141.12C540.608 142.88 544.934 143.76 549.481 143.76H550.581V167.52ZM590.74 128.58C590.74 133.127 592.646 137.013 596.46 140.24C600.273 143.467 604.966 145.08 610.54 145.08C616.113 145.08 620.806 143.54 624.62 140.46C628.433 137.233 630.34 133.42 630.34 129.02C630.34 125.207 628.726 121.98 625.5 119.34C622.273 116.553 617.873 114.573 612.3 113.4C605.993 112.227 600.053 110.613 594.48 108.56C588.906 106.507 583.993 104.013 579.74 101.08C575.633 98 572.333 94.5533 569.84 90.74C567.493 86.9267 566.32 82.6733 566.32 77.98C566.32 72.9933 567.346 68.3 569.4 63.9C571.6 59.5 574.533 55.6867 578.2 52.46C582.013 49.0867 586.486 46.4467 591.62 44.54C596.753 42.6333 602.253 41.68 608.12 41.68C614.133 41.68 619.78 42.7067 625.06 44.76C630.486 46.6667 635.18 49.3067 639.14 52.68C643.1 56.0533 646.253 60.0133 648.6 64.56C650.946 69.1067 652.12 73.9467 652.12 79.08H625.72C625.72 74.8267 623.96 71.3067 620.44 68.52C617.066 65.5867 612.96 64.12 608.12 64.12C603.866 64.12 600.2 65.3667 597.12 67.86C594.186 70.3533 592.72 73.36 592.72 76.88C592.72 78.9333 593.526 80.84 595.14 82.6C596.753 84.2133 598.88 85.7533 601.52 87.22C604.306 88.54 607.386 89.7133 610.76 90.74C614.28 91.7667 617.873 92.6467 621.54 93.38C626.233 94.26 630.706 95.6533 634.96 97.56C639.213 99.32 642.953 101.667 646.18 104.6C649.406 107.387 651.973 110.76 653.88 114.72C655.786 118.533 656.74 122.933 656.74 127.92C656.74 133.347 655.493 138.48 653 143.32C650.653 148.16 647.353 152.413 643.1 156.08C638.993 159.6 634.153 162.387 628.58 164.44C623.006 166.493 616.993 167.52 610.54 167.52C604.233 167.52 598.22 166.493 592.5 164.44C586.926 162.387 582.013 159.6 577.76 156.08C573.653 152.56 570.353 148.453 567.86 143.76C565.513 139.067 564.34 134.007 564.34 128.58H590.74ZM707.264 82.82L763.364 5.59999H797.024L739.604 82.82L808.464 164H773.924L707.264 82.82ZM674.264 5.59999H701.544V164H674.264V5.59999ZM850.713 16.16C850.713 20.56 849.173 24.3 846.093 27.38C843.013 30.46 839.273 32 834.873 32C830.473 32 826.733 30.46 823.653 27.38C820.573 24.3 819.033 20.56 819.033 16.16C819.033 11.76 820.573 8.01999 823.653 4.93999C826.733 1.85999 830.473 0.319996 834.873 0.319996C839.273 0.319996 843.013 1.85999 846.093 4.93999C849.173 8.01999 850.713 11.76 850.713 16.16ZM848.073 164H821.673V45.2H848.073V164ZM960.764 98.66C960.764 94.1133 959.884 89.86 958.124 85.9C956.511 81.7933 954.238 78.2733 951.304 75.34C948.518 72.26 945.144 69.84 941.184 68.08C937.224 66.32 933.044 65.44 928.644 65.44C924.244 65.44 920.064 66.32 916.104 68.08C912.144 69.84 908.698 72.26 905.764 75.34C902.978 78.2733 900.704 81.7933 898.944 85.9C897.331 89.86 896.524 94.1133 896.524 98.66V164H870.124V100.2C870.124 92.1333 871.664 84.58 874.744 77.54C877.824 70.3533 882.004 64.12 887.284 58.84C892.564 53.56 898.724 49.38 905.764 46.3C912.951 43.22 920.578 41.68 928.644 41.68C936.711 41.68 944.264 43.22 951.304 46.3C958.491 49.38 964.724 53.56 970.004 58.84C975.284 64.12 979.464 70.3533 982.544 77.54C985.624 84.58 987.164 92.1333 987.164 100.2V164H960.764V98.66ZM1128.25 127.26C1125.9 133.127 1122.68 138.553 1118.57 143.54C1114.61 148.38 1109.99 152.633 1104.71 156.3C1099.43 159.82 1093.56 162.533 1087.11 164.44C1080.8 166.493 1074.2 167.52 1067.31 167.52C1058.36 167.52 1049.93 165.907 1042.01 162.68C1034.09 159.307 1027.2 154.76 1021.33 149.04C1015.46 143.32 1010.77 136.647 1007.25 129.02C1003.88 121.393 1002.19 113.253 1002.19 104.6C1002.19 95.9467 1003.88 87.8067 1007.25 80.18C1010.77 72.5533 1015.46 65.88 1021.33 60.16C1027.2 54.44 1034.09 49.9667 1042.01 46.74C1049.93 43.3667 1058.36 41.68 1067.31 41.68C1076.4 41.68 1084.84 43.3667 1092.61 46.74C1100.53 49.9667 1107.42 54.44 1113.29 60.16C1119.3 65.88 1124 72.5533 1127.37 80.18C1130.74 87.8067 1132.43 95.9467 1132.43 104.6C1132.43 107.533 1132.21 110.467 1131.77 113.4H1029.69C1030.72 117.8 1032.4 121.833 1034.75 125.5C1037.1 129.167 1039.88 132.393 1043.11 135.18C1046.48 137.82 1050.22 139.947 1054.33 141.56C1058.44 143.027 1062.76 143.76 1067.31 143.76C1073.91 143.76 1080 142.293 1085.57 139.36C1091.14 136.28 1095.62 132.247 1098.99 127.26H1128.25ZM1067.31 65.44C1062.91 65.44 1058.73 66.1733 1054.77 67.64C1050.81 68.96 1047.22 70.8667 1043.99 73.36C1040.76 75.8533 1037.9 78.86 1035.41 82.38C1033.06 85.7533 1031.3 89.4933 1030.13 93.6H1104.49C1103.32 89.4933 1101.56 85.7533 1099.21 82.38C1096.86 78.86 1094 75.8533 1090.63 73.36C1087.4 70.8667 1083.81 68.96 1079.85 67.64C1075.89 66.1733 1071.71 65.44 1067.31 65.44ZM1209.08 167.52H1205.78C1197.86 167.52 1190.38 166.053 1183.34 163.12C1176.44 160.04 1170.43 155.933 1165.3 150.8C1160.16 145.667 1156.06 139.653 1152.98 132.76C1150.04 125.72 1148.58 118.24 1148.58 110.32V5.59999H1174.98V45.2H1209.08V68.08H1174.98V110.76C1174.98 115.307 1175.86 119.633 1177.62 123.74C1179.38 127.7 1181.72 131.147 1184.66 134.08C1187.59 137.013 1191.04 139.36 1195 141.12C1199.1 142.88 1203.43 143.76 1207.98 143.76H1209.08V167.52ZM1258.92 16.16C1258.92 20.56 1257.38 24.3 1254.3 27.38C1251.22 30.46 1247.48 32 1243.08 32C1238.68 32 1234.94 30.46 1231.86 27.38C1228.78 24.3 1227.24 20.56 1227.24 16.16C1227.24 11.76 1228.78 8.01999 1231.86 4.93999C1234.94 1.85999 1238.68 0.319996 1243.08 0.319996C1247.48 0.319996 1251.22 1.85999 1254.3 4.93999C1257.38 8.01999 1258.92 11.76 1258.92 16.16ZM1256.28 164H1229.88V45.2H1256.28V164ZM1340.81 143.76C1347.85 143.76 1354.23 142 1359.95 138.48C1365.81 134.96 1370.43 130.413 1373.81 124.84H1402.19C1399.99 131 1396.91 136.72 1392.95 142C1388.99 147.28 1384.29 151.827 1378.87 155.64C1373.59 159.307 1367.72 162.167 1361.27 164.22C1354.81 166.42 1347.99 167.52 1340.81 167.52C1331.86 167.52 1323.43 165.907 1315.51 162.68C1307.59 159.307 1300.69 154.76 1294.83 149.04C1288.96 143.32 1284.27 136.647 1280.75 129.02C1277.37 121.393 1275.69 113.253 1275.69 104.6C1275.69 95.9467 1277.37 87.8067 1280.75 80.18C1284.27 72.5533 1288.96 65.88 1294.83 60.16C1300.69 54.44 1307.59 49.9667 1315.51 46.74C1323.43 43.3667 1331.86 41.68 1340.81 41.68C1347.99 41.68 1354.81 42.78 1361.27 44.98C1367.72 47.0333 1373.66 49.9667 1379.09 53.78C1384.51 57.5933 1389.21 62.14 1393.17 67.42C1397.13 72.7 1400.21 78.4933 1402.41 84.8H1374.03C1370.65 78.9333 1366.03 74.24 1360.17 70.72C1354.3 67.2 1347.85 65.44 1340.81 65.44C1335.53 65.44 1330.54 66.4667 1325.85 68.52C1321.15 70.5733 1317.05 73.36 1313.53 76.88C1310.01 80.4 1307.22 84.58 1305.17 89.42C1303.11 94.1133 1302.09 99.1733 1302.09 104.6C1302.09 110.027 1303.11 115.16 1305.17 120C1307.22 124.693 1310.01 128.8 1313.53 132.32C1317.05 135.84 1321.15 138.627 1325.85 140.68C1330.54 142.733 1335.53 143.76 1340.81 143.76Z" fill="#F41858" />
                                <path d="M1427.08 167.3C1422.68 167.3 1418.94 165.76 1415.86 162.68C1412.78 159.6 1411.24 155.86 1411.24 151.46C1411.24 147.06 1412.78 143.32 1415.86 140.24C1418.94 137.16 1422.68 135.62 1427.08 135.62C1431.48 135.62 1435.22 137.16 1438.3 140.24C1441.38 143.32 1442.92 147.06 1442.92 151.46C1442.92 155.86 1441.38 159.6 1438.3 162.68C1435.22 165.76 1431.48 167.3 1427.08 167.3Z" fill="white" />
                            </svg>

                        </Link>
                        {currentUser ?

                            <ul className="navbar-nav mb-0 flex-row ms-3 justify-content-start">
                                {/* logged in desktop */}
                                <li className="nav-item ms-md-3 me-md-3 dropdown">
                                    <NavLink
                                        className="nav-link fw-normal border-body-text"
                                        activeclassname="active"
                                        to="/fixtures-listing"
                                    >Fixture listing
                                    </NavLink>
                                </li>
                                <li className="nav-item ms-md-3 me-md-3">
                                    <NavLink
                                        className="nav-link fw-normal border-body-text"
                                        activeclassname="active"
                                        to="/track-record"
                                    >Track record
                                    </NavLink>
                                </li>
                            
                                <li
                                    className="nav-item ms-md-3 me-md-3 dropdown"
                                >
                                    <NavLink
                                        className={`nav-link fw-normal dropdown-toggle border-body-text ${insightPaths.includes(location.pathname) ? 'active' : ''}`}
                                        to="/ai-summaries"
                                        activeclassname="active"
                                        id="InsightsandNews"
                                    >
                                        News
                                    </NavLink>
                                    <ul className="dropdown-menu bg-transparent py-1 shadow-0 ">
                                        <div className="bg-dark-mode-50 mt-1 py-1 rounded-2">
                                            <li className="nav-item dropdown mx-3 my-1">
                                                <NavLink
                                                    className="nav-link fw-normal border-body-text fw-normal small "
                                                    activeclassname="active"
                                                    to="/ai-summaries">AI summaries
                                                </NavLink>
                                            </li>
                                            <li className="nav-item dropdown mx-3 my-1">
                                                <NavLink
                                                    className="nav-link fw-normal border-body-text fw-normal small "
                                                    activeclassname="active"
                                                    to="/my-news">My news
                                                </NavLink>
                                            </li>
                                            <li className="nav-item dropdown mx-3 my-1">
                                                <NavLink
                                                    className="nav-link fw-normal border-body-text fw-normal small "
                                                    activeclassname="active"
                                                    to="/saved/following/players">Following
                                                </NavLink>
                                            </li>
                                            <li className="nav-item dropdown mx-3 my-1">
                                                <NavLink
                                                    className="nav-link fw-normal border-body-text fw-normal small "
                                                    activeclassname="active"
                                                    to="/saved/news">Saved articles
                                                </NavLink>
                                            </li>
                                            <li className="nav-item dropdown mx-3 my-1">
                                                <NavLink
                                                    className="nav-link fw-normal text-nowrap border-body-text fw-normal small "
                                                    activeclassname="active"
                                                    to="/saved/searches">Saved searches
                                                </NavLink>
                                            </li>
                                        </div>
                                    </ul>
                                </li>

                                <li
                                    className="nav-item ms-md-3 me-md-3 dropdown"
                                >
                                    <NavLink
                                        className={`nav-link fw-normal dropdown-toggle border-body-text ${teamsPaths.includes(location.pathname) ? 'active' : ''}`}
                                        activeclassname="active"
                                        to="/teams-listing">Teams
                                    </NavLink>

                                    <ul className="dropdown-menu bg-transparent py-1 shadow-0 ">
                                        <div className="bg-dark-mode-50 mt-1 py-1 rounded-2">
                                            <li className="nav-item dropdown mx-3 my-1">
                                                <NavLink
                                                    className="nav-link fw-normal text-nowrap border-body-text fw-normal small "
                                                    activeclassname="active"
                                                    to="/reports/team-transfer-analysis">Team transfer analysis
                                                </NavLink>
                                            </li>
                                            <li className="nav-item dropdown mx-3 my-1">
                                                <NavLink
                                                    className="nav-link fw-normal text-nowrap border-body-text fw-normal small "
                                                    activeclassname="active"
                                                    to="/teams-listing">Teams
                                                </NavLink>
                                            </li>
                                        </div>
                                    </ul>
                                </li>
                            </ul>

                            : location.pathname === '/' ? (

                                <ul className="navbar-nav mb-0 flex-row align-items-center justify-content-start bg-dark-mode-500 rounded-pill">
                                    {/* not logged in  desktop */}
                                    <li className="nav-item ">
                                        <a
                                            className={`nav-link fw-semi-bold small no-bottom-border glow-border py-3 px-5 ${activeSection === 'Walkthrough' ? 'active' : ''}`}
                                            href="#Walkthrough"
                                            onClick={e => handleScrollToSection(e, 'Walkthrough')}
                                        >
                                            Walkthrough
                                        </a>

                                    </li>
                                    <li className="nav-item ">
                                        <a
                                            href="#Features"
                                            className={`nav-link fw-semi-bold small no-bottom-border glow-border py-3 px-5 ms-2 ${activeSection === 'Features' ? 'active' : ''}`}
                                            onClick={e => handleScrollToSection(e, 'Features')}
                                        >
                                            Features
                                        </a>
                                    </li>
                                    <li className="nav-item ">
                                        <a
                                            href="#Pricing"
                                            className={`nav-link fw-semi-bold small no-bottom-border glow-border py-3 px-5 ms-2 ${activeSection === 'Pricing' ? 'active' : ''}`}
                                            onClick={e => handleScrollToSection(e, 'Pricing')}
                                        >
                                            Pricing
                                        </a>
                                    </li>
                                </ul>

                            ) : null}

                        <div className={`${currentUser ? 'flex-1 d-flex justify-content-end me-auto' : ''}`}>
                            {/* rhs menu */}
                            <div className='d-flex align-items-center'>

                                {currentUser ? (
                                    <>
                                        {/* logged in rhs menu */}
                                        <i ref={playerSearchTarget} onClick={() => setShowPlayerSearch(!showPlayerSearch)} className='cursor-pointer fa-light fa-magnifying-glass me-4' ></i>
                                        <Link to={'/account/notification/inbox'} className='position-relative'>
                                            <i className='fa-light fa-bell me-4'></i>
                                            {unreadCount > 0 && (
                                                <div className='disc-25 rounded-circle bg-crayola-red-500 position-absolute top-75 start-40 translate-middle'></div>
                                            )}
                                        </Link>
                                        <Overlay target={playerSearchTarget.current} show={showPlayerSearch} placement="left">
                                            {({

                                                ...props
                                            }) => (
                                                <div
                                                    {...props}
                                                    style={{
                                                        position: 'absolute',
                                                        marginRight: '0.75rem',
                                                        zIndex: 9999,
                                                        ...props.style,
                                                    }}
                                                >
                                                    <span className='react-bootstrap-typeahead-desktop'>
                                                        <PlayerSearchTypeahead onSelect={onPlayerSearchTypeaheadSelect} />
                                                    </span>
                                                </div>
                                            )}
                                        </Overlay>
                                        <Link to="/account" className="d-flex align-items-center justify-content-center rounded-circle mb-2 bg-white disc-55">
                                            <div className="d-flex align-items-center justify-content-center rounded-circle w-100 h-100">
                                                <i className="fa-light fa-user-gear fs-5 text-black"></i>
                                            </div>
                                        </Link>
                                        {false && <Dropdown>
                                            <Dropdown.Toggle
                                                className="bg-dark-mode-900 border-0 d-flex align-items-center extra-small fw-semi-bold p-0 no-psuedo-after">
                                                <div className="btn btn-link px-0 bg-transparent text-white" >
                                                    <i className="fa-light  fa-user-gear  fs-4"></i>
                                                </div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu show={showAccountDropdown} className="rounded-2 bg-dark-mode-500 mt-2">
                                                <Dropdown.Item as="div" className="border-bottom border-neutral-gray-900 py-3 px-4 bg-transparent">
                                                    <Link to="/account" onClick={() => setShowAccountDropdown(false)} className="d-flex w-100 text-decoration-none text-white">
                                                        <div className="d-flex  justify-content-start align-items-center ">

                                                            <div>
                                                                <div className="d-flex align-items-center">
                                                                    <p className="mb-0 small fw-semi-bold text-nowrap">{currentUser.name}</p>
                                                                </div>
                                                                <p className="extra-small mb-0 text-truncate max-w-f-200">{currentUser.email}</p>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </Dropdown.Item>
                                                <HeaderStripePortalLink />
                                                <Dropdown.Item as="div" className="border-bottom border-neutral-gray-900 py-3 px-4 bg-transparent">
                                                    <Link to="/account" onClick={() => setShowAccountDropdown(false)} className="small">
                                                        Manage my account
                                                    </Link>
                                                </Dropdown.Item>
                                                <Dropdown.Item as="div" className="border-bottom border-neutral-gray-900 py-3 px-4 bg-transparent">
                                                    <Link to="/feedback" className="small">
                                                        Send feedback
                                                    </Link>
                                                </Dropdown.Item>

                                                <div className="py-3 px-4 text-decoration-none fw-semi-bold rounded-2">
                                                    <p
                                                        className="mb-0 w-fit-content small cursor-pointer"
                                                        onClick={handleLogout}
                                                    >
                                                        Logout <i className="ms-2 fa-light fa-arrow-right-from-bracket"></i>
                                                    </p>
                                                </div>
                                            </Dropdown.Menu>
                                        </Dropdown>}
                                    </>
                                ) : (
                                    <div className={`d-flex ${location.pathname === '/sign-up' ? 'me-4' : 'min-w-px-224'}`}>
                                        {/* not logged in rhs menu */}
                                        {false && <div className="btn btn-md bg-transparent text-decoration-none small me-2" onClick={() => navigate('/register')}>Sign up</div>}

                                        {location.pathname === '/sign-up' ? '' :
                                            <Link to="/sign-up" className="btn btn-md bg-transparent text-decoration-none small me-2" >Get started</Link>}

                                        <div className="btn btn-md bg-crayola-red-500 text-decoration-none small" onClick={() => navigate('/login')}>Login</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </nav>
            </div>


            <div className='container d-md-none d-block'>
                {/* mobile header */}
                <div className='d-flex justify-content-between align-items-center border rounded-pill px-3 py-2 bg-dark-mode-900 border-dark-mode-50'>
                    <div className={`d-flex align-items-center ${!currentUser ? ' justify-content-between w-100' : ''} `}>
                        <div className="btn btn-link px-0 me-2 bg-transparent" onClick={handleMenuOpen}>
                            <i className="fa-light fa-bars "></i>
                        </div>
                        <Link to={`${currentUser ? '/dashboard' : '/'}`}> <img src={sk} alt='Sk logo' className='mt-n1' /></Link>
                        {currentUser ? '' : <div className='mb-0 me-3 d-flex flex-1 justify-content-end align-items-center'>
                            {location.pathname === '/sign-up' ?
                                <Link to="/login" className="btn btn-md bg-white text-black text-decoration-none small fw-semi-bold  rounded-2">Login</Link>
                                :
                                <Link to="/sign-up" className="btn btn-md bg-white text-black text-decoration-none small fw-semi-bold  rounded-2">Get started</Link>
                            }
                        </div>}
                    </div>
                    {currentUser
                        ? <div className='d-flex align-items-center'>
                            {/* logged in mobile header */}
                            <i ref={playerSearchMobileTarget} onClick={() => toggleShowMobilePlayerSearch()} className='cursor-pointer fa-light fa-magnifying-glass me-4'></i>
                            <Link to={'/account/notification/inbox'} className='position-relative'>
                                <i className='fa-light fa-bell me-4'></i>
                                {unreadCount > 0 && (
                                    <div className='disc-25 rounded-circle bg-crayola-red-500 position-absolute top-75 start-40 translate-middle'></div>
                                )}
                            </Link>
                            <Link to="/account" className="d-flex align-items-center justify-content-center rounded-circle bg-white disc-5">
                                <div className="d-flex align-items-center justify-content-center rounded-circle w-100 h-100">
                                    <i className="fa-light fa-user-gear text-black"></i>
                                </div>
                            </Link>
                        </div> :
                        <>
                        </>
                    }
                </div>
                <Overlay target={playerSearchMobileTarget.current} show={showMobilePlayerSearch} placement="bottom">
                    {({

                        ...props
                    }) => (
                        <div className="px-3 mt-5 z-index-modal-backdrop"
                            {...props}
                            style={{
                                position: 'absolute',
                                marginLeft: '-5px',
                                paddingTop: '1rem',
                                backgroundColor: '#20232A',
                                width: '100%',
                                height: '100%',
                                ...props.style,
                            }}
                        >
                            <div onClick={() => toggleShowMobilePlayerSearch()} className="d-flex align-items-center text-decoration-none mb-3">
                                <i className="fa-light fa-arrow-left me-3"></i>
                            </div>

                            <PlayerSearchTypeahead onSelect={onPlayerSearchTypeaheadSelect} isMobileView={true} />
                        </div>
                    )}
                </Overlay>
            </div>

            <Offcanvas show={show} onHide={closeMenu} placement="start" className="min-vw-100 bg-black z-index-modal-backdrop">
                <Offcanvas.Body>
                    <div>
                        {/* mobile nav */}
                        <div className='d-flex justify-content-between align-items-center'>
                            <div className={`d-flex align-items-center `}>
                                <button type="button" className="disc-3 bg-transparent fio-fs-4 btn-close m-0 p-0 me-3 text-white" onClick={closeMenu} aria-label="Close"></button>
                                <Link to={`${currentUser ? '/dashboard' : '/'}`}> <img src={sk} alt='Sk logo' /></Link>
                            </div>
                            {currentUser ? <div className='d-flex align-items-center'>
                                {/* logged in mobile nav */}
                                <i ref={playerSearchMobileTarget} onClick={() => toggleShowMobilePlayerSearch()} className='cursor-pointer fa-light fa-magnifying-glass'></i>
                                <Link to="/account" className="ms-4 d-flex align-items-center justify-content-center rounded-circle bg-white disc-5">
                                    <div className="d-flex align-items-center justify-content-center rounded-circle w-100 h-100">
                                        <i className="fa-light fa-user-gear text-black"></i>
                                    </div>
                                </Link>
                            </div> :
                                <>
                                    {/* not logged in mobile nav */}
                                    <Link
                                        to="/sign-up"
                                        className="btn btn-md bg-white text-black text-decoration-none small"
                                    >
                                        Get started
                                    </Link>
                                </>}
                        </div>
                        {currentUser ?
                            <ul className="navbar-nav mt-4 w-100">
                                {/* logged in mobile nav */}
                                <li className="nav-item w-100 mt-3half mb-1">
                                    <NavLink
                                        onClick={closeMenu}
                                        className="d-block fw-normal text-decoration-none small  bg-active-dark-mode-500 bg-hover-dark-mode-500 px-2 py-1 rounded-1 w-100"
                                        activeclassname="active"
                                        to="/fixtures-listing"><i className='fa-light fa-users w-px-22'></i>Fixture listing
                                    </NavLink>
                                </li>
                                <li className="nav-item w-100 mb-1">
                                    <NavLink
                                        onClick={closeMenu}
                                        className="d-block fw-normal text-decoration-none small  bg-active-dark-mode-500 bg-hover-dark-mode-500 px-2 py-1 rounded-1 w-100"
                                        activeclassname="active"
                                        to="/track-record"><i className='fa-light fa-chart-radar w-px-22'></i>Track record
                                    </NavLink>
                                </li>
                             

                                <li className="nav-item mt-3half mb-2 px-2 text-neutral-gray-700 extra-small">NEWS</li>
                                <li className="nav-item w-100 mb-1">
                                    <NavLink
                                        onClick={closeMenu}
                                        className="d-block fw-normal text-decoration-none small bg-active-dark-mode-500 bg-hover-dark-mode-500 px-2 py-1 rounded-1 w-100"
                                        activeclassname="active"
                                        to="/ai-summaries"><i className='fa-light fa-brain w-px-22'></i>AI summaries
                                    </NavLink>
                                </li>
                                <li className="nav-item w-100 mb-1">
                                    <NavLink
                                        onClick={closeMenu}
                                        className="d-block fw-normal text-decoration-none small  bg-active-dark-mode-500 bg-hover-dark-mode-500 px-2 py-1 rounded-1 w-100"
                                        activeclassname="active"
                                        to="/my-news"
                                    ><i className='fa-light fa-newspaper w-px-22'></i>My News
                                    </NavLink>
                                </li>
                                <li className="nav-item w-100 mb-1">
                                    <NavLink
                                        onClick={closeMenu}
                                        className="d-block fw-normal text-decoration-none small  bg-active-dark-mode-500 bg-hover-dark-mode-500 px-2 py-1 rounded-1 w-100"
                                        activeclassname="active"
                                        to="/saved/following/players"
                                    >
                                        <i className='fa-light fa-binoculars w-px-22'></i>Following
                                    </NavLink>
                                </li>
                                <li className="nav-item w-100 mb-1">
                                    <NavLink
                                        onClick={closeMenu}
                                        className="d-block fw-normal text-decoration-none small  bg-active-dark-mode-500 bg-hover-dark-mode-500 px-2 py-1 rounded-1 w-100"
                                        activeclassname="active"
                                        to="/saved/news"
                                    >
                                        <i className='fa-light fa-newspaper w-px-22'></i>Saved articles
                                    </NavLink>
                                </li>
                                <li className="nav-item w-100 mb-1">
                                    <NavLink
                                        onClick={closeMenu}
                                        className="d-block fw-normal text-decoration-none small  bg-active-dark-mode-500 bg-hover-dark-mode-500 px-2 py-1 rounded-1 w-100"
                                        activeclassname="active"
                                        to="/saved/searches"
                                    >
                                        <i className='fa-light fa-search w-px-22'></i>Saved searches
                                    </NavLink>
                                </li>
                                <li className="nav-item mt-3half mb-2 text-neutral-gray-700 px-2 extra-small">TEAMS</li>
                                <li className="nav-item w-100 mb-1">
                                    <NavLink
                                        onClick={closeMenu}
                                        className="d-block fw-normal text-nowrap text-decoration-none small  bg-active-dark-mode-500 bg-hover-dark-mode-500 px-2 py-1 rounded-1 w-100"
                                        activeclassname="active"
                                        to="/reports/team-transfer-analysis"><i className='fa-light fa-arrows-rotate w-px-22'></i>Team transfer analysis
                                    </NavLink>
                                </li>
                                <li className="nav-item w-100 mb-1">
                                    <NavLink
                                        onClick={closeMenu}
                                        className="d-block fw-normal text-decoration-none small  bg-active-dark-mode-500 bg-hover-dark-mode-500 px-2 py-1 rounded-1 w-100"
                                        activeclassname="active"
                                        to="/teams-listing"><i className="fa-light fa-people-group w-px-22"></i>Teams
                                    </NavLink>
                                </li>

                                <li className="nav-item mt-3half w-100 mb-1">
                                    <div
                                        onClick={handleLogout}
                                        className="d-block fw-normal text-decoration-none small  bg-active-dark-mode-500 bg-hover-dark-mode-500 px-2 py-1 rounded-1 w-100"
                                    > <i className='fa-light fa-sign-out w-px-22'></i>
                                        Logout
                                    </div>
                                </li>

                            </ul>
                            :
                            <ul className="navbar-nav mt-4 w-100">
                                {/* not logged in mobile nav */}
                                <li className="nav-item mb-2 px-2 text-neutral-gray-700 extra-small">PRODUCT</li>
                                <li className="nav-item w-100 mb-1">
                                    <NavLink
                                        onClick={closeMenu}
                                        className="d-block fw-normal text-decoration-none small bg-active-dark-mode-500 bg-hover-dark-mode-500 px-2 py-1 rounded-1 w-100"
                                        activeclassname="active"
                                        to={`${currentUser ? '/dashboard' : '/'}`}><i className='fa-light fa-house w-px-22'></i>Home
                                    </NavLink>
                                </li>
                                <li className="nav-item w-100 mb-1">
                                    <NavLink
                                        onClick={closeMenu}
                                        className="d-block fw-normal text-decoration-none small bg-active-dark-mode-500 bg-hover-dark-mode-500 px-2 py-1 rounded-1 w-100"
                                        activeclassname="active"
                                        to="/track-record"><i className='fa-light fa-chart-radar w-px-22'></i>Track record
                                    </NavLink>
                                </li>
                                
                                <li className="nav-item mt-3half mb-2 text-neutral-gray-700 px-2 extra-small">MY ACCOUNT</li>
                                <li className="nav-item w-100 mb-1">
                                    <NavLink
                                        onClick={closeMenu}
                                        className="d-block fw-normal text-decoration-none extra-small bg-active-dark-mode-500 bg-hover-dark-mode-500 px-2 py-1 rounded-1 w-100"
                                        activeclassname="active"
                                        to="/sign-up"><i className='fa-light fa-user-gear w-px-22'></i>Get started
                                    </NavLink>
                                </li>
                                <li className="nav-item w-100 mb-1">
                                    <NavLink
                                        onClick={closeMenu}
                                        className="d-block fw-normal text-decoration-none extra-small bg-active-dark-mode-500 bg-hover-dark-mode-500 px-2 py-1 rounded-1 w-100"
                                        activeclassname="active"
                                        to="/login"><i className='fa-light fa-arrow-right-to-bracket w-px-22'></i>Login
                                    </NavLink>
                                </li>

                            </ul>
                        }
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </header>
    )
}

export default Header;